import { pages, pagesWithoutHeader } from './modules';

const routes = [
  // Initial Routes
  {
    path: '*',
    redirect: {
      name: 'checkIn',
      meta: {
        publicRoute: true,
      }
    }
  },

  {
    path: '/',
    name: 'hostname-url',
    component: () => import('@/views/unitSelection/SelectUnit.vue'),
    meta: {
      publicRoute: true,
      disabledPageReloadGuard: true
    },
  },

  // Views with header template
  {
    path: '',
    component: () => import('@/views/templates/MainTemplate.vue'),
    children: [
      ...pages
    ],
  },

  // Views without header template
  ...pagesWithoutHeader,

  {
    path: '/:brandId/:unitId/covid/:teamName',
    name: 'checkInTeam',
    component: () => import('@/views/checkin/Checkin.view.vue'),
    meta: {
      disabledPageReloadGuard: true,
      publicRoute: true,
    },
  },

  {
    path: '/:brandId/:unitId/:admissionID?',
    name: 'checkIn',
    component: () => import('@/views/checkin/Checkin.view.vue'),
    meta: {
      disabledPageReloadGuard: true,
      publicRoute: true,
    },
  },

  {
    path: '/:brandId/:unitId/covid/:teamName',
    name: 'checkInCovid',
    component: () => import('@/views/checkin/Checkin.view.vue'),
    meta: {
      disabledPageReloadGuard: true,
      publicRoute: true,
    },
  },

  {
    path: '/colaboradores',
    name: 'collaborators',
    component: () => import('@/views/collaborators/Collaborators.vue'),
    meta: {
      disabledPageReloadGuard: true,
      publicRoute: true,
    },
  },

  {
    path: '/selecionar-marca',
    name: 'select-brand',
    component: () => import('@/views/unitSelection/SelectBrand.vue'),
    meta: {
      disabledPageReloadGuard: true,
      publicRoute: true,
    },
  },

  {
    path: '/:brandName',
    name: 'select-unit',
    component: () => import('@/views/unitSelection/SelectUnit.vue'),
    meta: {
      disabledPageReloadGuard: true,
      publicRoute: true,
    },
  },
];

export default routes;
